/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/snippets/image-alt-text.js":
/*!************************************************!*\
  !*** ./src/scripts/snippets/image-alt-text.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var app_utils_accessibility_imageAltText_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! app/utils/accessibility/imageAltText.mjs */ \"./src/utils/accessibility/imageAltText.mjs\");\n\n(0,app_utils_accessibility_imageAltText_mjs__WEBPACK_IMPORTED_MODULE_0__.keepImageAltTextReadable)(document);\n\n//# sourceURL=webpack://oath.com-shopify/./src/scripts/snippets/image-alt-text.js?\n}");

/***/ }),

/***/ "./src/utils/accessibility/imageAltText.mjs":
/*!**************************************************!*\
  !*** ./src/utils/accessibility/imageAltText.mjs ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   keepImageAltTextReadable: () => (/* binding */ keepImageAltTextReadable),\n/* harmony export */   readableAltText: () => (/* binding */ readableAltText)\n/* harmony export */ });\nconst MEDIA_GROUP_TAG = /^(?<description>.*?)\\s*#[^#_]+_(?<optionValue>[^#]+)$/;\n\nconst readableAltText = (alt) => {\n  const tagged = alt.match(MEDIA_GROUP_TAG);\n  if (!tagged) {\n    return alt;\n  }\n  const { description, optionValue } = tagged.groups;\n  return description.trim() || optionValue.trim();\n};\n\nconst makeAltReadable = (image) => {\n  const alt = image.getAttribute('alt');\n  if (alt === null) {\n    return;\n  }\n  const readable = readableAltText(alt);\n  if (readable !== alt) {\n    image.setAttribute('alt', readable);\n  }\n};\n\nconst imagesIn = (node) => {\n  if (node.nodeType !== Node.ELEMENT_NODE) {\n    return [];\n  }\n  return node.tagName === 'IMG' ? [node] : Array.from(node.querySelectorAll('img[alt*=\"#\"]'));\n};\n\nconst keepImageAltTextReadable = (root) => {\n  root.querySelectorAll('img[alt*=\"#\"]').forEach(makeAltReadable);\n  const observer = new MutationObserver((records) => {\n    records.forEach((record) => {\n      const changedImages = record.type === 'attributes' ? [record.target] : Array.from(record.addedNodes).flatMap(imagesIn);\n      changedImages.forEach(makeAltReadable);\n    });\n  });\n  observer.observe(root.body ?? root, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt'] });\n  return observer;\n};\n\n\n//# sourceURL=webpack://oath.com-shopify/./src/utils/accessibility/imageAltText.mjs?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/snippets/image-alt-text.js");
/******/ 	
/******/ })()
;